var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"ma-0 mt-n1 font-12"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_setup.props.titulo)+": ")]),_vm._v("\n  "+_vm._s(_setup.props.valor)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }